import React, {useEffect, useRef} from 'react';
import './App.css';
import { BrowserRouter as Router, useLocation, useNavigate } from "react-router-dom";
//import { Helmet } from "react-helmet-async";
import AppRoutes from "./routes/AppRoutes";
import Header from './components/Headers/Header';
import Footer from './components/Footer/Footer';
import { isTokenExpired } from "../src/utils/Auth/auth";
import { trackVisitor } from "../src/utils/visitorTraker";

interface User {
  id: string;
  name: string;
}

// interface AppProps {
//   user?: User;
// }

const getUser = (): User | null => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};
// This component must be INSIDE <Router>
function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const startTimeRef = useRef<number>(Date.now());
  const user = getUser(); // ✅ FIX
  const userId = user?.id;
  const userName = user?.name;
/* ── Auto-logout when JWT expires ── */
  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem("token");
      // Only redirect if the user is actually logged in and the token has expired
      if (token && isTokenExpired(token)) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // Dispatch storage event so Header updates immediately
        window.dispatchEvent(new Event("storage"));
        // Only redirect to login if on a page that requires auth
        const publicPrefixes = [
          "/", "/login", "/register", "/forgot-password", "/reset-password",
          "/blogs", "/mcqs", "/online-test-series", "/about-us", "/contact-us",
          "/terms-and-conditions", "/privacy-policy", "/site-maps", "/disclaimer",
          "/search", "/courses", "/live-classes",
        ];
        const isPublic = publicPrefixes.some(p =>
          location.pathname === p || location.pathname.startsWith(p + "/")
        );
        if (!isPublic) {
          navigate("/login", { replace: true, state: { from: location.pathname } });
        }
      }
    };
 
    // Check immediately on mount and on every route change
    checkToken();
 
    // Then re-check every 30 seconds in the background
    const interval = setInterval(checkToken, 30_000);
    return () => clearInterval(interval);
  }, [location.pathname, navigate]);

  useEffect(() => {
    const currentPath = location.pathname;

    // PAGE VISIT
    trackVisitor({
      userId: userId,
      name: userName,
      page: currentPath,
      action: "page_visit"
    });

    // reset timer
    startTimeRef.current = Date.now();

    return () => {
      const duration = Math.floor(
        (Date.now() - startTimeRef.current) / 1000
      );

      // TIME SPENT
      trackVisitor({
        userId: userId,
        name: userName,
        page: currentPath,
        action: "time_spent",
        duration
      });
    };
  }, [location.pathname, userId, userName]);

  // TAB CLOSE / REFRESH
  useEffect(() => {
    const handleUnload = () => {
      const duration = Math.floor(
        (Date.now() - startTimeRef.current) / 1000
      );

      const payload = {
        userId: userId,
        name: userName,
        page: window.location.pathname,
        action: "time_spent",
        duration
      };

      const blob = new Blob([JSON.stringify(payload)], {
        type: "application/json"
      });

      navigator.sendBeacon("/api/v1/visitors/track", blob);
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, [userId, userName]);

  //const hideHeaderFooter = location.pathname.startsWith("/online-tests/test-page") && location.pathname.startsWith("/online-tests/test-solutions");
  const hideHeaderFooter = ["/online-tests/test-page", "/online-tests/test-solutions", "/online-tests/instructions"]
  .some(prefix => location.pathname.startsWith(prefix));
  React.useEffect(() => {
    if (hideHeaderFooter) {
      document.body.classList.add("test-page-body");
    } else {
      document.body.classList.remove("test-page-body");
    }
  }, [hideHeaderFooter]);
  console.log(location.pathname);
  return (
    <div className="App">
      {/* ✅ Only load ads script when not in test pages */}
      {/* {!hideHeaderFooter && (
        <Helmet>
          <script
            async
            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7684933817684584"
            crossOrigin="anonymous"
          ></script>
        </Helmet>
      )} */}
      {!hideHeaderFooter && <Header />}
      <AppRoutes />
      {!hideHeaderFooter && <Footer />}
    </div>
  );
}
function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;
